export const ExpressionBookmarkStorageKey = "logs.expression.bookmarks.v1";

export type ExpressionBookmark = {
    id: string;
    name: string;
    expression: string;
    createdAt: number;
};

type BookmarkCandidate = Partial<Record<keyof ExpressionBookmark, unknown>>;

function isExpressionBookmark(value: unknown): value is ExpressionBookmark {
    if (!value || typeof value !== "object")
        return false;

    const candidate = value as BookmarkCandidate;

    return (
        typeof candidate.id === "string"
        && typeof candidate.name === "string"
        && typeof candidate.expression === "string"
        && typeof candidate.createdAt === "number"
    );
}

export function loadExpressionBookmarks(storage: Pick<Storage, "getItem"> = localStorage): ExpressionBookmark[] {
    try {
        const parsed: unknown = JSON.parse(storage.getItem(ExpressionBookmarkStorageKey) ?? "[]");

        return Array.isArray(parsed)
            ? parsed.filter(isExpressionBookmark)
            : [];

    } catch {
        return [];
    }
}

export function saveExpressionBookmarks(
    bookmarks: ExpressionBookmark[],
    storage: Pick<Storage, "setItem"> = localStorage,
) {
    storage.setItem(ExpressionBookmarkStorageKey, JSON.stringify(bookmarks));
}

export function createExpressionBookmarkId() {
    return globalThis.crypto?.randomUUID?.() ?? `${Date.now()}-${Math.random().toString(36).slice(2)}`;
}
